import { render, staticRenderFns } from "./setChoosePicByText.vue?vue&type=template&id=3f9734d0&scoped=true"
import script from "./setChoosePicByText.vue?vue&type=script&lang=js"
export * from "./setChoosePicByText.vue?vue&type=script&lang=js"
import style0 from "./setChoosePicByText.vue?vue&type=style&index=0&id=3f9734d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9734d0",
  null
  
)

export default component.exports